import React from "react";
import { SkeletonBlock } from "./Skeleton";

/**
 * Order-ticket skeleton — the Trade ticket while it prefills (symbol, live
 * price, existing order values).
 *
 * Trade uses reusable primitives for launch, so this is deliberately a plain
 * arrangement of field-shaped blocks at the ticket's real control heights.
 *
 * Two things it must never do: show a price or total placeholder (a "$0.00"
 * where a live price goes is the worst possible lie in a trading ticket), and
 * draw a grey block where the Place Order button sits.
 */
const OrderTicketSkeleton = ({ compact = false }) => {
  const h = compact ? 36 : 44;
  return (
    <div className="space-y-4" aria-busy="true" aria-label="Order ticket loading">
      {/* Buy / Sell pair */}
      <div>
        <SkeletonBlock height={12} width={72} />
        <div className="flex gap-3 mt-2">
          <SkeletonBlock height={h} className="flex-1" rounded="rounded-lg" />
          <SkeletonBlock height={h} className="flex-1" rounded="rounded-lg" />
        </div>
      </div>

      {/* Order type row */}
      <div>
        <SkeletonBlock height={12} width={84} />
        <div className="flex gap-2 mt-2">
          <SkeletonBlock height={h} className="flex-1" rounded="rounded-lg" />
          <SkeletonBlock height={h} className="flex-1" rounded="rounded-lg" />
          <SkeletonBlock height={h} className="flex-1" rounded="rounded-lg" />
        </div>
      </div>

      {/* Quantity + price fields */}
      <div>
        <SkeletonBlock height={12} width={64} />
        <SkeletonBlock height={h} className="mt-2" rounded="rounded-lg" />
      </div>
      <div>
        <SkeletonBlock height={12} width={54} />
        <SkeletonBlock height={h} className="mt-2" rounded="rounded-lg" />
      </div>

      {/* Estimated total */}
      <div className="flex items-center justify-between">
        <SkeletonBlock height={12} width={76} />
        <SkeletonBlock height={16} width={96} />
      </div>
    </div>
  );
};

export default OrderTicketSkeleton;
